import { render, staticRenderFns } from "./AddVehicleMake.vue?vue&type=template&id=e2df2856"
import script from "./AddVehicleMake.vue?vue&type=script&lang=ts"
export * from "./AddVehicleMake.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports